import { electron } from 'lib-shared-electron';

/**
 * Checks if the desktop app is unsupported
 *
 * We are no longer supporting electron without electron exposed on the window
 * object
 */
export function isDesktopAppVersionUnsupported(): boolean {
  return electron.isElectron() && !window.electron;
}
